module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 475
// module chunks = 0